import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useBusinessAuthContext } from "../commoncomponents/useBusinessAuthContext";
import API_URL from "../../api/API";
import WaiverActionsDropdown from "./WaiverActionsDropdown";

const WaiverCard = ({ waiver, onDisable, newVersionWaiver }) => {

  const TOTAL_STEPS = 5;
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [openDropdownId, setOpenDropdownId] = useState(null);

  const statusLabelMap = {
    published: "Active",
    draft: "Draft",
    disabled: "Disabled",
    archived_by_admin: "Disabled",
    archived_by_new_version: "Auto Disabled (New Version Creation)",
    archived_by_location_deletion: "Auto Disabled (Location Deleted)",
    // future statuses go here
  };

  const isActive = waiver.waiverStatus === "published";

  const isArchived =
    waiver.waiverStatus === "archived_by_admin" ||
    waiver.waiverStatus === "archived_by_new_version" ||
    waiver.waiverStatus === "archived_by_location_deletion";

  const archivedDate = waiver.archivedAt
  ? new Date(waiver.archivedAt).toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    })
  : null;  


  const handleEdit = () => {
    if (waiver.waiverStatus === "draft") {

      ///when all steps are completed
      if (waiver.currentStep === TOTAL_STEPS) {
        navigate(`/business/waiverbuilder/smart/${waiver._id}/review`);
      }
      const nextStep = waiver.currentStep + 1;

      navigate(`/business/waivereditor/${waiver._id}`);

      /*navigate(
        `/business/waiverbuilder/smart/${waiver._id}/step-${nextStep}`
      );*/

                

      /*navigate(
        `/business/waiverbuilder/smart/${waiver._id}/step-${waiver.currentStep}`
      );*/
    } else {
      //cannot edit published and archived waivers, without creating a new version and changing existing to draft
      //navigate(`/business/waiver/${waiver._id}/edit`);
    }
  };

 
  return (
    <div className="bg-white rounded-xl shadow-sm p-5 flex justify-between items-center">
      <div>
        
        <div className="font-medium">
          {isArchived ? (
            <button
              onClick={() =>
                navigate(`/business/waiverviewer/${waiver._id}`)
              }
              className="text-left hover:underline text-blue-600"
            >
              {waiver.serviceName} Waiver
            </button>
          ) : isActive ? (
            <button
              onClick={() =>
                navigate(`/business/active-waiver/${waiver._id}`)
              }
              className="text-left hover:underline text-blue-600"
            >
              {waiver.serviceName} Waiver
            </button>
          ) : (
            `${waiver.serviceName} Waiver`
          )}
        </div>

        <div className="text-sm text-muted-foreground">
          {waiver.waiverStatus === "published"
            ? waiver.signatureCountCurrentVersion || 0
            : waiver.signatureCountAllVersions || 0} signatures
        </div>
        <div className="text-sm text-muted-foreground">
          Locations: {waiver.locationNames || "—"}
        </div>

        {isArchived && archivedDate && (
          <div className="text-sm text-muted-foreground">
            Archived {archivedDate}
          </div>
        )}
      </div>

      <div className="flex items-center gap-4">
        <span
          className={`px-3 py-1 text-xs rounded-full ${
            waiver.waiverStatus === "published"
              ? "bg-green-100 text-green-700"
              : "bg-yellow-100 text-yellow-700"
          }`}
        >
          {statusLabelMap[waiver.waiverStatus] || waiver.waiverStatus}
        </span>

        <WaiverActionsDropdown
          waiver={waiver}
          newVersionWaiver={newVersionWaiver}
          isOpen={openDropdownId === waiver._id}
          setOpenDropdownId={setOpenDropdownId}
          onEdit={handleEdit}
          onDisable={() => onDisable(waiver._id)}
        />

      </div>
    </div>
  );
};

export default WaiverCard;